import Menu from "./Menu";
import { classNames } from "primereact/utils";
import PropTypes from 'prop-types';
import { useContext, useMemo } from "react";
import { LayoutContext } from "../../context/LayoutContext";
import { ReactComponent as OperatorIcon } from '../../assets/images/operator.svg';
import { ReactComponent as AdminIcon } from '../../assets/images/admin.svg';
import { useTranslation } from "react-i18next";
import { AccessLevel, useAuth } from "../../hook/useAuth";

const Sidebar = ({ collapsed, ...props }) => {
    const { sidebarCollapsed, setSidebarCollapsed, isMobile } = useContext(LayoutContext);
    const { t } = useTranslation();
    const { getAccessLevel } = useAuth();
    const accessLevel = useMemo(() => getAccessLevel());

    const collapseMenu = () => {
        setSidebarCollapsed(prev => !prev);
    }

    return (
        <aside>
            <div className={classNames('sidebar', { 'collapsed': sidebarCollapsed })}>
                <div className="sidebar-header" style={{ zIndex: 99 }}>
                    <div className="subtract" />
                    <div className="sidebar-header-text">VendPORTAL</div>
                    {!isMobile && <div className="sidebar-toggle-icon" onClick={() => collapseMenu()} />}
                </div>

                <div className="sidebar-container" style={{ zIndex: 100 }}>
                    <div className={`access-level-wrapper ${sidebarCollapsed ? 'collapsed' : ''}`}>
                        {(accessLevel == AccessLevel.OPERATOR || accessLevel === AccessLevel.ADMIN) &&
                            <div className='access-level'>
                                <div className='ellipse' />
                                {accessLevel === AccessLevel.OPERATOR && (
                                    <>
                                        <OperatorIcon className='access-level-icon' />
                                        <span className='access-level-text'>{t('accessLevel.operator')}</span>
                                    </>
                                )}
                                {accessLevel === AccessLevel.ADMIN && (
                                    <>
                                        <AdminIcon className='access-level-icon' />
                                        <span className='access-level-text'>{t('accessLevel.admin')}</span>
                                    </>
                                )}
                            </div>
                        }
                    </div>
                    <Menu mode={sidebarCollapsed ? 'slim' : 'static'} />
                </div>

                <div className='sidebar-background-vector-wrapper' style={{ zIndex: 0 }}>
                    <div className='sidebar-background-vector' />
                </div>
            </div>
        </aside>
    )
}

Sidebar.propTypes = {
    collapsed: PropTypes.bool,
};

export default Sidebar;